module.exports = __webpack_public_path__ + "static/media/eng-flag.b398ba42.svg";